export const LoyaltyProgramLinks = {
  DE: 'https://www.jackpots.ch/de/loyalty-program',
  EN: 'https://www.jackpots.ch/en/loyalty-program',
  FR: 'https://www.jackpots.ch/fr/loyalty-program',
  IT: 'https://www.jackpots.ch/it/loyalty-program',
}
